import React from 'react'
import styles from "./loader.module.css"

function Loader({mainMsg = '', subMsg = '', status = ''}) {
    return (
      <div className={styles.loader}>
        { mainMsg && <code>{mainMsg}</code> }
        <div className={styles['animated-logo']}>
          <img src="/VXI_ANIMATED_LOADER.gif" alt="" />
        </div>
        { subMsg && <code>{subMsg}</code> }
        { status && <div className={styles.status}>{status}</div> }
      </div>
    )
  }

export default Loader
